import { Show } from 'react-admin';
import { StatementShowFields } from '../fields/StatementFields';
export const StatementShow = () => (
    <Show>
        <StatementShowFields />
    </Show>
);
